import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTES } from '@common/interfaces';

/** Admin-only branches: allows users whose primary role is ADMIN (redirects others to sign-in). */
export const adminGuard: CanActivateFn = () => {
  const router = inject(Router);
  try {
    const userDetails = JSON.parse(
      localStorage.getItem('userInfo') as string
    );
    if (userDetails?.roles?.[0] === 'ADMIN') {
      return true;
    }
  } catch {
    // userInfo absent or invalid JSON — treat as unauthenticated
  }
  router.navigate([ROUTES.SIGN_IN]);
  return false;
};
